import { render, staticRenderFns } from "./ProductFiscal.vue?vue&type=template&id=56b8db8f&"
import script from "./ProductFiscal.vue?vue&type=script&lang=js&"
export * from "./ProductFiscal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports